import { forNamespace } from 'common/lib/util/i18n';
import moment from 'moment';
const format = forNamespace();

const ABSOLUTE_DATE_FORMAT = 'MMM D [at] LT';

export const isDateToday = (date: Date) =>
  moment(date).isSame(Date.now(), 'day');

export const formatAbsoluteDate = (date: number) =>
  moment(date).format(ABSOLUTE_DATE_FORMAT);

export const idToDate = (id: string): Date =>
  new Date(1000 * parseInt(id.substr(0, 8), 16));

export const formatHumanDate = (date: Date) => {
  const momentDate = moment(new Date(date));
  const now = moment();

  const isAmbiguousMonth = Math.abs(now.diff(momentDate, 'months')) > 9;
  const shouldHideYear = momentDate.isSame(now, 'year') && !isAmbiguousMonth;

  return momentDate.format(shouldHideYear ? 'llll' : 'll');
};

export const getDateDeltaString = (
  date: Date,
  now: Date,
): 'just now' | string => {
  const dateObj = moment(date);
  const nowObj = moment(now);

  if (dateObj.isSame(nowObj, 'day')) {
    if (Math.abs(nowObj.diff(date, 'seconds')) < 10) {
      return format('just now');
    } else {
      return dateObj.from(now);
    }
  } else {
    return dateObj.calendar(now);
  }
};



// WEBPACK FOOTER //
// ./app/gamma/src/util/dates.ts